/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * ID of the deleted message
     * @type {string}
     * @memberof InlineObject8
     */
    messageId: string;
    /**
     * Channel where message was deleted
     * @type {string}
     * @memberof InlineObject8
     */
    channelId: string;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof InlineObject8
     */
    botToken: string;
}

export function InlineObject8FromJSON(json: any): InlineObject8 {
    return InlineObject8FromJSONTyped(json, false);
}

export function InlineObject8FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject8 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'channelId': json['channelId'],
        'botToken': json['botToken'],
    };
}

export function InlineObject8ToJSON(value?: InlineObject8 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'channelId': value.channelId,
        'botToken': value.botToken,
    };
}


